import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import SwiperCore from 'swiper';
import { Store } from '@ngrx/store';
import { ThemeActions } from '../../../core/state/theme/theme.actions';
import { selectSettings } from '../../../core/state/theme/theme.selectors';
import { CodeBonusService } from '../../../core/services/code-bonus.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { selectUser } from '../../../core/state/auth/auth.selector';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';
import { NetworkService } from '../../../core/services/ui/network.service';
import { SupportModeService } from '../../../core/services/ui/support-mode.service';
import {
  NETWORK_QUALITY,
  NetworkQuality,
} from '../../../core/constants/constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public elem: any;
  public bonusBalanceData: any[] = [];
  public isLoading: boolean = true;
  private subscriptions: Subscription[] = [];
  public countryId = 1;
  public codeBonus$ = this.store.select(selectUser);
  public country: number | null = null;
  public agentId: any = null;
  public roleId: number | null = null;
  public networkQuality: NetworkQuality = NETWORK_QUALITY.GOOD;
  public canUseSupportMode$ = this.supportModeService.isAllowed$;
  public isSupportModeOn$ = this.supportModeService.isEnabled$;

  constructor(
    public layout: LayoutService,
    public navServices: NavService,
    private bonusCodeService: CodeBonusService,
    private _toastr: ToastrService,
    @Inject(DOCUMENT) private document: any,
    private store: Store,
    private router: Router,
    private authService: AuthService,
    private networkService: NetworkService,
    private supportModeService: SupportModeService,
  ) {
    this.codeBonus$.subscribe((profileData) => {
      this.roleId = profileData.id_rol;
      this.agentId = profileData.idusuario;
      this.country = profileData.id_pais;
      this.getBalanceBonus();
    });
  }

  ngOnInit() {
    this.elem = document.documentElement;
    this.loadTheme();
    this.getBalanceBonus();

    const networkSubscription = this.networkService.networkQuality$.subscribe(
      (quality) => {
        this.networkQuality = quality;
      },
    );
    this.subscriptions.push(networkSubscription);
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    this.navServices.megaMenu = false;
    this.navServices.levelMenu = false;
  }

  getBalanceBonus(): void {
    this.isLoading = true;
    const subscription = this.bonusCodeService
      .getAgentBalance({ agentId: this.agentId })
      .subscribe({
        next: (res) => {
          const response = res.data;

          this.bonusBalanceData = response.bonusBalance;
          this.isLoading = false;
        },
        error: (error) => {
          this._toastr.error('Internal server error', 'Error');
          this.isLoading = false;
        },
      });

    this.subscriptions.push(subscription);
  }
  reloadTable() {
    this.isLoading = true;
    this.getBalanceBonus();
  }
  layoutToggle() {
    document.body.classList.toggle('dark-only');
    const layoutVersion = document.body.classList.contains('dark-only')
      ? 'dark-only'
      : '';
    this.store.dispatch(
      ThemeActions['[Theme]Change']({
        settings: {
          layout_version: layoutVersion,
        },
      }),
    );
    // Save the layout version to localStorage
    localStorage.setItem('layoutVersion', layoutVersion);
  }
  loadTheme(): void {
    const layoutVersion = localStorage.getItem('layoutVersion');
    if (layoutVersion === 'dark-only') {
      document.body.classList.add('dark-only');
    }
  }
  searchToggle() {
    this.navServices.search = true;
  }

  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
    }
  }

  lockSystem() {
    this.authService.lock();
    this.router.navigate(['/auth/unlock-user']);
  }

  toggleSupportMode() {
    this.supportModeService.toggle();
  }

  get networkIconClass(): string {
    return 'fas fa-wifi';
  }

  get networkTooltip(): string {
    switch (this.networkQuality) {
      case NETWORK_QUALITY.GOOD:
        return 'Conexión estable';
      default:
        return 'Conexión intermitente';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
